export default {
  namespaced: true,

  state: {
    recordList: [],
    mobileNo: '',
    serviceNo: '',
    channelCode: '',
    apiUrl: '', // 私有化部署，接口地址
    websocketUrl: '', // 私有化部署，websocket连接地址
    queryParams: {}, // 路由上的query参数，上行消息接口时需带上
  },
  mutations: {
    minusPrice (state, params) {
      // this.$store.commit('minusPrice', 2)
    },
    setRecordList (state, params) {
      const { mobileNo, serviceNo } = state
      const recordListString = JSON.stringify(params)
      localStorage.setItem(`${serviceNo}+${mobileNo}+recordList`, recordListString)
      state.recordList = params
    },
    setState (state, params) {
      Object.assign(state, params)
    }
  },
  actions: {
    count ({ dispatch, commit, state }, params) {

    }
  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/chatRoom/model.js